export default __webpack_public_path__ + "static/media/SA.5b0ef756.svg";